import { useTranslate } from '@growtherapy/i18n';
import { Button } from '@growtherapy/sprout-ui';

import { Maybe } from '../../types';
import { CoachInteractionsTable } from './CoachInteractionsTable';
import { ResourcesTable } from './ResourcesTable';

export function ActivitySectionContent({
  hasCoachAccess,
  coachTopics,
  messagesSent,
  completedResources,
  onClick,
}: {
  hasCoachAccess: boolean;
  coachTopics: string[];
  messagesSent: number;
  completedResources: Maybe<string[]>;
  onClick: () => void;
}): JSX.Element {
  const t = useTranslate();

  return (
    <div className='flex flex-col rebrand:gap-350'>
      {hasCoachAccess && <CoachInteractionsTable topics={coachTopics} messagesSent={messagesSent} />}
      {completedResources && <ResourcesTable resources={completedResources} />}
      <Button use='link' onClick={onClick}>
        {t('telehealth-core:providerIntersessionSummary.viewActivity')}
      </Button>
    </div>
  );
}
